var _path, _path2, _path3;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpam(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "384pt",
    viewBox: "0 0 384 384",
    width: "384pt",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m279.992188 9.375c-6.046876-6.046875-14.082032-9.375-22.625-9.375h-130.75c-8.546876 0-16.578126 3.328125-22.625 9.375l-94.609376 94.609375c-6.054687 6.039063-9.382812 14.070313-9.382812 22.640625.0390625 24.015625.167969 106.71875.0625 130.734375-.03125 8.578125 3.296875 16.640625 9.378906 22.710937l94.550782 94.554688c6.046874 6.046875 14.078124 9.375 22.625 9.375h130.75c8.542968 0 16.578124-3.328125 22.625-9.375l94.625-94.625c6.046874-6.039062 9.375-14.078125 9.375-22.632812v-130.734376c0-8.542968-3.328126-16.585937-9.375-22.632812zm72 248-94.625 94.625h-130.75l-94.554688-94.550781c.105469-24.082031-.023438-106.832031-.0625-130.832031l94.617188-94.617188h130.75l94.625 94.632812zm0 0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m191.992188 64c-8.640626 0-16.863282 3.710938-22.585938 10.191406-5.71875 6.472656-8.375 15.105469-7.335938 23.425782l14.019532 128.125c.886718 8.113281 7.734375 14.257812 15.902344 14.257812 8.167968 0 15.015624-6.144531 15.902343-14.265625l13.984375-127.871094c1.074219-8.566406-1.582031-17.199219-7.304687-23.671875-5.71875-6.480468-13.941407-10.191406-22.582031-10.191406zm0 0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m191.992188 272c-13.230469 0-24 10.769531-24 24s10.769531 24 24 24c13.230468 0 24-10.769531 24-24s-10.769532-24-24-24zm0 0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpam);
export default __webpack_public_path__ + "static/media/spam.a621220b.svg";
export { ForwardRef as ReactComponent };